import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  incidentId: "",
  loading: false,
  tactics: []
};

export const mitreSlice = createSlice({
  name: "mitre",
  initialState,
  reducers: {
    setIncidentMitreTactics: (state, action) => {
      const {id} = action.payload;
      state.incidentId = id;
      state.loading = true;
      state.tactics = [];
    },
    setIncidentMitreTacticsSuccess: (state, action) => {
      state.incidentId = "";
      state.loading = false;
      state.tactics = action?.payload || [];
    },
    setIncidentMitreTacticsFailure: (state) => {
      state.incidentId = "";
      state.loading = false;
      state.tactics = [];
    }
  }
});

export const {
  setIncidentMitreTactics,
  setIncidentMitreTacticsSuccess,
  setIncidentMitreTacticsFailure
} = mitreSlice.actions;

export default mitreSlice.reducer;
